"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMutateAllowedAdapter = exports.isMutateAllowed = exports.isPathPermissionAllowed = exports.getOperationModePathPermissions = exports.operationModePathPermissions = void 0;
const lodash_1 = __importDefault(require("lodash"));
const common_1 = require("@finley-technologies/common");
exports.operationModePathPermissions = {
    admin: ['*'],
    client: [
        // metadata needs to be stubbed from proposed lender ca into actual ca
        // readonly metadata on FE
        'id',
        '_schemaVersion_',
        '_currentCreditAgreementId_',
        'effectiveTo',
        // editable metadata on FE
        '_note_',
        'effectiveFrom',
        'version',
        // actual sections that are exposed
        'borrowingBaseMechanics.calcAgentMechanics.*',
        'portfolioCovenants',
        'portfolioCovenants[]',
        'portfolioCovenants[].*',
    ],
};
const getOperationModePathPermissions = (operationMode) => exports.operationModePathPermissions[operationMode];
exports.getOperationModePathPermissions = getOperationModePathPermissions;
const isPathPermissionAllowed = ({ permissionPath, path, }) => {
    (0, common_1.finleyAssert)(permissionPath.length > 0, 'permission path must not be empty');
    const pathSegments = path.split('.');
    const permissionSegments = permissionPath.split('.');
    const lastPermissionSegment = lodash_1.default.last(permissionSegments);
    (0, common_1.finleyAssert)(lastPermissionSegment, 'last permission segment must exist');
    // if permission ends with *, deeply extend to match all subpaths
    // such that we do not need to manually declare all subpaths
    // individually
    if (lastPermissionSegment === '*') {
        // eslint-disable-next-line no-restricted-syntax
        while (permissionSegments.length < pathSegments.length) {
            permissionSegments.push('*');
        }
    }
    if (permissionSegments.length !== pathSegments.length)
        return false;
    // eslint-disable-next-line no-restricted-syntax
    for (let idx = 0; idx < pathSegments.length; idx += 1) {
        const permissionSeg = permissionSegments[idx];
        if (permissionSeg === '*')
            continue;
        const pathSeg = pathSegments[idx].replace(/\[[0-9]+\]/g, '[]'); // replace array indexes with numberless brackets []
        if (permissionSeg === pathSeg)
            continue;
        return false;
    }
    return true;
};
exports.isPathPermissionAllowed = isPathPermissionAllowed;
const isMutateAllowed = ({ path, operationMode, }) => {
    const pathPermissions = (0, exports.getOperationModePathPermissions)(operationMode);
    return lodash_1.default.some(pathPermissions, (permissionPath) => (0, exports.isPathPermissionAllowed)({ permissionPath, path }));
};
exports.isMutateAllowed = isMutateAllowed;
const isMutateAllowedAdapter = (operationMode) => {
    return (path) => (0, exports.isMutateAllowed)({ path, operationMode });
};
exports.isMutateAllowedAdapter = isMutateAllowedAdapter;
//# sourceMappingURL=wipPermissions.js.map